export const useGetSkyOlightToken = () => {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get('token');
};
